<div class="full-screen-loader" *ngIf="isAppLoading$ | async">
    <div class="loader-container">
        <div class="spinner"></div>
    </div>
</div>
